// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-banner {
    position: relative;
    width: 100%;
    margin-top: 91px;
  }

  .top-banner::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.25) 55%, rgba(0, 0, 0, 0) 100%);
    z-index: 1;
  }

  .top-banner-img {
    width: 100%;
    height: auto;
    display: block;
  }

  .top-banner-content {
    position: absolute;
    top: 50%;
    left: 6%;
    transform: translateY(-50%);
    max-width: 52%;
    color: #ffffff;
    z-index: 2;
  }

  .top-banner-heading {
    font-size: 2.75rem;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  .top-banner-highlight {
    font-weight: 700;
    color: #eaa637;
  }

  .top-banner-text {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.25rem;
  }


  @media (max-width: 992px) {
    .top-banner-content {
      max-width: 65%;
    }

    .top-banner-heading {
      font-size: 2.1rem;
    }
  }

  @media (max-width: 768px) {
    .top-banner-content {
      max-width: 90%;
      left: 5%;
    }

    .top-banner-heading {
      font-size: 1.6rem;
    }

    .top-banner-text {
      font-size: 0.85rem;
      margin-bottom: 0.75rem;
    }
  }

  @media (max-width: 576px) {
    .top-banner {
      margin-top: 70px;
      min-height: 360px;
    }

    .top-banner-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .top-banner-content {
      max-width: 92%;
    }

    .top-banner-break {
      display: none;
    }
  }

  @media (max-width: 480px) {
    .top-banner {
      min-height: 320px;
    }

    .top-banner-heading {
      font-size: 1.2rem;
    }

    .top-banner-text {
      font-size: 0.75rem;
      line-height: 1.5;
    }
  }

  .bottomNavbar{
    background-color: #172639;
    width: 100%;
  }


  .customCard1{
    border: 1px solid rgb(224, 224, 224);
    border-radius: 10px;
    box-shadow: 1px 10px 20px rgba(148, 148, 148, 0.5);
    padding: 0!important;
  }

  .customCard{
    border: 1px solid rgb(224, 224, 224);
    border-radius: 10px;
    box-shadow: 1px 10px 20px rgba(148, 148, 148, 0.5);
    padding: 0!important;
  }


  .customAnchor{
    text-decoration: none;
    color: blue;
    cursor: default;
  }
  .customAnchor1{
    text-decoration: none;
    color: blue;
    cursor: pointer;
  }

  .customHeader{
    background-color: #172639;
    color: #eaa637;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 10px 0;
  }
  
  .customList {
    list-style: none;
  }
`, "",{"version":3,"sources":["webpack://./src/pages/Pages.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,4GAA4G;IAC5G,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;;;EAGA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,cAAc;MACd,QAAQ;IACV;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;EACF;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;;EAGA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,kDAAkD;IAClD,oBAAoB;EACtB;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,kDAAkD;IAClD,oBAAoB;EACtB;;;EAGA;IACE,qBAAqB;IACrB,WAAW;IACX,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":[".top-banner {\n    position: relative;\n    width: 100%;\n    margin-top: 91px;\n  }\n\n  .top-banner::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.25) 55%, rgba(0, 0, 0, 0) 100%);\n    z-index: 1;\n  }\n\n  .top-banner-img {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n\n  .top-banner-content {\n    position: absolute;\n    top: 50%;\n    left: 6%;\n    transform: translateY(-50%);\n    max-width: 52%;\n    color: #ffffff;\n    z-index: 2;\n  }\n\n  .top-banner-heading {\n    font-size: 2.75rem;\n    font-weight: 400;\n    line-height: 1.2;\n    margin-bottom: 1rem;\n  }\n\n  .top-banner-highlight {\n    font-weight: 700;\n    color: #eaa637;\n  }\n\n  .top-banner-text {\n    font-size: 1rem;\n    line-height: 1.6;\n    margin-bottom: 1.25rem;\n  }\n\n\n  @media (max-width: 992px) {\n    .top-banner-content {\n      max-width: 65%;\n    }\n\n    .top-banner-heading {\n      font-size: 2.1rem;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .top-banner-content {\n      max-width: 90%;\n      left: 5%;\n    }\n\n    .top-banner-heading {\n      font-size: 1.6rem;\n    }\n\n    .top-banner-text {\n      font-size: 0.85rem;\n      margin-bottom: 0.75rem;\n    }\n  }\n\n  @media (max-width: 576px) {\n    .top-banner {\n      margin-top: 70px;\n      min-height: 360px;\n    }\n\n    .top-banner-img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .top-banner-content {\n      max-width: 92%;\n    }\n\n    .top-banner-break {\n      display: none;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .top-banner {\n      min-height: 320px;\n    }\n\n    .top-banner-heading {\n      font-size: 1.2rem;\n    }\n\n    .top-banner-text {\n      font-size: 0.75rem;\n      line-height: 1.5;\n    }\n  }\n\n  .bottomNavbar{\n    background-color: #172639;\n    width: 100%;\n  }\n\n\n  .customCard1{\n    border: 1px solid rgb(224, 224, 224);\n    border-radius: 10px;\n    box-shadow: 1px 10px 20px rgba(148, 148, 148, 0.5);\n    padding: 0!important;\n  }\n\n  .customCard{\n    border: 1px solid rgb(224, 224, 224);\n    border-radius: 10px;\n    box-shadow: 1px 10px 20px rgba(148, 148, 148, 0.5);\n    padding: 0!important;\n  }\n\n\n  .customAnchor{\n    text-decoration: none;\n    color: blue;\n    cursor: default;\n  }\n  .customAnchor1{\n    text-decoration: none;\n    color: blue;\n    cursor: pointer;\n  }\n\n  .customHeader{\n    background-color: #172639;\n    color: #eaa637;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    padding: 10px 0;\n  }\n  \n  .customList {\n    list-style: none;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
